export default "/images/vendor/@coreui/icons/svg/flag/cif-sv.svg?18c1f9ff0e2d6eabd5c576ae9fda7d9a";